import {
	createStore,
	combineReducers,
	applyMiddleware,
	compose
} from 'redux';
import {
	routerMiddleware,
	routerReducer
} from 'react-router-redux';
import thunk from 'redux-thunk';
import createHistory from 'history/createBrowserHistory';

// Call back
import authBigcommerceReducer from './containers/auth-bigcommerce-page/reducers';
import authShopifyReducer from './containers/auth-shopify-page/reducers';
import callbackBigcommerceAuthReducer from './containers/callback-bigcommerce-auth-page/reducers';
import callbackBigcommerceLoadReducer from './containers/callback-bigcommerce-load-page/reducers';
import callbackShopifyReducer from './containers/callback-shopify-page/reducers';
import callbackPaymentReducer from './containers/callback-payment-page/reducers';
// Checkouts
import dashboardCheckoutsReducer from './containers/dashboard-checkouts-page/reducers';
// Emails
import dashboardEmailsStatisticsReducer from './containers/dashboard-emails-statistics-page/reducers';
import dashboardEmailsReducer from './containers/dashboard-emails-page/reducers';
import dashboardEmailsActivityReducer from './containers/dashboard-emails-activity-page/reducers';
import dashboardEmailsSettingsReducer from './containers/dashboard-emails-settings-page/reducers';
import dashboardPaymentsReducer from './containers/dashboard-payments-page/reducers';
// New Feature
import whitelabelReducer from './containers/whitelabel-page/reducers';
import emailPlusReducer from './containers/email-plus-page/reducers';

export const history = createHistory();

// Initialize store
let store;

// Return a function so we can configure it
export default () => {
	if (store) {
		return store;
	}

	// add reducers here
	const reducers = {
		// others
		callbackPaymentReducer,
		authBigcommerceReducer,
		authShopifyReducer,
		callbackBigcommerceAuthReducer,
		callbackBigcommerceLoadReducer,
		callbackShopifyReducer,
		// checkouts
		dashboardCheckoutsReducer,
		// emails
		dashboardEmailsStatisticsReducer,
		dashboardEmailsReducer,
		dashboardEmailsActivityReducer,
		dashboardEmailsSettingsReducer,
		// payments
		dashboardPaymentsReducer,
		// new features
		whitelabelReducer,
		emailPlusReducer,
		routing: routerReducer
	};

	const initialState = {};
	const enhancers = [];
	const middleware = [
		thunk,
		routerMiddleware(history)
	];

	if (process.env.NODE_ENV === 'development') {
		const devToolsExtension = window.devToolsExtension;

		if (typeof devToolsExtension === 'function') {
			enhancers.push(devToolsExtension());
		}
	}

	// enhancers
	const composedEnhancers = compose(
		applyMiddleware(...middleware),
		...enhancers,
	);

	// create store
	store = createStore(
		combineReducers(reducers),
		initialState,
		composedEnhancers,
	);

	return store;
};



// WEBPACK FOOTER //
// ./src/store.js